import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Vue from "vue";
import VueI18n from 'vue-i18n';
import App from "./App.vue";
import store from "@/store/store";
import * as VueGoogleMaps from "vue2-google-maps";
import BootstrapVue from 'bootstrap-vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueCarousel from 'vue-carousel';
import VueScrollReveal from 'vue-scroll-reveal';
import VueLazyLoad from 'vue-lazyload';
import Moment from 'vue-moment';
import VueCookies from 'vue-cookies';
import BabelPolyFill from 'babel-polyfill';
import VueHtml2Canvas from 'vue-html2canvas';
import _ from 'lodash';

import Api from "@/api/api";
import WcApi from "@/api/wc-api";
import AuthApi from "@/api/authApi";
import InpostApi from "@/api/inpostApi";
import router from '@/router';
import lang_pl from '@/locale/pl';
import lang_it from '@/locale/it';
import lang_de from '@/locale/de';
import lang_fr from '@/locale/fr';
import lang_en from '@/locale/en';
import "@/registerServiceWorker";


Vue.use(VueI18n)
Vue.use(new Api());
Vue.use(new WcApi());
Vue.use(new AuthApi());
Vue.use(new InpostApi());
Vue.use(BootstrapVue);
Object.defineProperty(Vue.prototype, "$_", { value: _ });
Vue.use(VueCookies);
// Vue.use(Html2Canvas);
Vue.use(VueHtml2Canvas);
Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
	load: {
		key: "AIzaSyAnnF9VWqfb7KQMD9dxE-CAoECdM1vrvHc",
		libraries: "places" // necessary for places input
	}
});

const moment = require('moment');
require('moment/locale/pl');
require('moment/locale/en-gb');
require('moment/locale/fr');
require('moment/locale/de');
require('moment/locale/it');
Vue.use(Moment, {
  moment
});

Vue.use(VueScrollReveal, {
  class: 'v-scroll-reveal', // A CSS class applied to elements with the v-scroll-reveal directive; useful for animation overrides.
  duration: 800,
  scale: 1,
  origin: 'left',
  distance: '10px',
  mobile: false
});

library.add(fas);
library.add(far);
library.add(fab);
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueCarousel);
Vue.use(VueLazyLoad);

Vue.filter('confLink', function (value) {
  if (typeof value !== 'string') {
    value = value.url;
  }
  if (!value) return '';
  const link = new URL(value);
  return link.pathname + link.search;
})

Vue.filter('money', function (value) {
  if (!value) return '';
  return parseFloat(value).toFixed(2).toString().replace('.', ',');
})

const i18n = new VueI18n({
  locale: store.getters.lang || 'pl', // set locale
  messages: {
    pl: lang_pl,
    it: lang_it,
    fr: lang_fr,
    en: lang_en,
    de: lang_de
  }, // set locale messages
});

// Sentry.init({
//   dsn: 'https://cd95e2d0f8714ab790fcf21ede393938@sentry.io/1393290' ,
//   integrations: [new Sentry.Integrations.Vue()]
// });

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
